export default __webpack_public_path__ + "static/teacher-app-fb8951415ea59b9bcf31f34340dfaa0a.mp4";